<template>
  <div id="content">
    <h2 class="title">部分发明专利证书(共九十余项专利)</h2>
    <el-row :gutter="20">
      <el-col
        v-for="(x, i) in patent"
        :key="i"
        :xs="24"
        :sm="12"
        :md="8"
        :lg="6"
        :xl="6"
      >
        <ImageCardCover class="ImageCardCover" v-bind="x"></ImageCardCover>
      </el-col>
    </el-row>
  </div>
</template>

<style scoped>
#content {
  overflow-x: hidden;
  overflow-y: scroll;
}
.el-row {
  padding: 0 16px;
}
.ImageCardCover {
  display: block;
  margin: 0 auto;
}
.el-col {
  text-align: center;
}
.title {
  height: 44px;
  background-color: #409eff;
  color: #ffffff;
  line-height: 44px;
  padding: 0 32px;
  font-size: 20px;
  margin-bottom: 32px;
}
</style>

<script>
// import ImageCard from "@/components/ImageCard.vue";
import ImageCardCover from "@/components/ImageCardCover.vue";

export default {
  components: {
    // ImageCard,
    ImageCardCover
  },
  data() {
    return {
      patent: []
    };
  },
  created() {
    //生命周期vue实例创建后,做数据安排
    let arr = [
      `用于模拟变压器中局部放电的系统`,
      `变压器油色谱检测装置检验用油的智能存储装置`,
      `用于变压器局部放电诊断的智能机器人`,
      `变压器呼吸器用的冷凝罩`,
      `外置加热元件的变压器温控器`,
      `用于变压器温控器的冲液装置`,
      `一种用于变压器油中气体在线检测的直线活塞式进样装置`,
      `变压器用气体继电器`,
      `变压器用速动油压继电器`
    ];
    let res = [];
    for (var i in arr) {
      let x = i - 0 + 1;
      res.push({
        path: require("@/assets/patent/" + x + ".jpg"),
        title: arr[i]
      });
    }
    this.patent = res;
  }
};
</script>
